import { IReportRequest } from 'peekdata-datagateway-api-sdk';
import { IReport } from 'src/models/report';
import { IAction } from 'src/state/action';
import { IAsyncState } from '../action';

// #region -------------- Action types -------------------------------------------------------------------

export const actionTypes = {
  loadReport: 'report/LOAD_REPORT',
  setReportRequest: 'report/SET_REPORT_REQUEST',
  reportLoaded: 'report/REPORT_LOADED',
  openModal: 'report/OPEN_MODAL',
  closeModal: 'report/CLOSE_MODAL',
  changeReportTitle: 'report/CHANGE_REPORT_TITLE',
  saveReport: 'report/SAVE_REPORT',
  reportSaved: 'report/REPORT_SAVED',
  removeMessage: 'report/REMOVE_MESSAGE',
};

// #endregion

// #region-------------- Actions-------------------------------------------------------------------

export function loadReport(payload: string): IAction {
  return {
    type: actionTypes.loadReport,
    payload,
  };
}

export function reportLoaded(payload: IAsyncState<IReport>): IAction {
  return {
    type: actionTypes.reportLoaded,
    payload,
  };
}

export function setReportRequest(payload: IReportRequest): IAction {
  return {
    type: actionTypes.setReportRequest,
    payload,
  };
}

export function openModal(): IAction {
  return {
    type: actionTypes.openModal,
  };
}

export function closeModal(): IAction {
  return {
    type: actionTypes.closeModal,
  };
}

export function changeTitle(payload: string): IAction {
  return {
    type: actionTypes.changeReportTitle,
    payload,
  };
}

export function saveReport(): IAction {
  return {
    type: actionTypes.saveReport,
  };
}

export function reportSaved(payload: IAsyncState<IReport>): IAction {
  return {
    type: actionTypes.reportSaved,
    payload,
  };
}

export function removeMessage(): IAction {
  return {
    type: actionTypes.removeMessage,
  };
}

// #endregion
